import {Button, Pagination, Tooltip, Empty, Checkbox, Grid} from 'antd';
import {Table, Switch, Space} from 'antd';
import {useEffect, useRef, useState} from "react";
import {v4} from "uuid";
import {useDataGrid} from "./DataGridContext";
import {useTranslation} from "react-i18next";
import {ClearOutlined, CloseOutlined, EyeOutlined, ReloadOutlined, UnorderedListOutlined} from "@ant-design/icons";
import {useModal} from "../../context/ModalContext";
import ColumnFilter from "../ColumnFilter";
import {isMobile} from "react-device-detect";


const SORT = {
    NONE: -1,
    ASC: 0,
    DESC: 1
}

export const RenderableExpandRow = ({children, expanded, recordId}) => {

    const {t} = useTranslation();
    const {renderItem, renderExpandedRow, refreshDataGrid} = useDataGrid()
    const [item, setItem] = useState('');

    useEffect(() => {
        if (renderItem && renderItem.recordId === recordId) {
            setItem(renderItem)
        }
    }, [renderItem])

    return (
        <>
            {
                expanded && (
                    <div key={item.key}>
                        {/*<Tooltip placement={'bottomLeft'} title={t('Refresh')}>*/}
                        {/*    <Button onClick={() => {*/}
                        {/*        renderExpandedRow(recordId)*/}
                        {/*    }}>*/}
                        {/*        <ReloadOutlined/>*/}
                        {/*    </Button>*/}
                        {/*</Tooltip>*/}
                        {children}
                    </div>
                )
            }
        </>
    )
}

export default function DataGrid({title, scale=0.8}) {
    const {t} = useTranslation();
    const {
        resultModel,
        dataGridProps,
        setSelectedRows,
        onFilterPageSort,
        tableId,
        selectedRows,
        queryModel,
        focusOut,
        refreshDataGrid
    } = useDataGrid()
    const {openModal, closeModal} = useModal()
    const screens = Grid.useBreakpoint();
    const isNarrowViewport = !screens.md; // < 768px
    const [rowSelection, setRowSelection] = useState({
        selectedRowKeys: selectedRows.map(x => x[dataGridProps.rowKey || 'id']),
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRows(selectedRows)
        },
        onSelect: (record, selected, selectedRows) => {

        },
        onSelectAll: (selected, selectedRows, changeRows) => {
        }
    })

    useEffect(() => {
        if (selectedRows) {
            setRowSelection({
                ...rowSelection,
                selectedRowKeys: selectedRows.map(x => x[dataGridProps.rowKey || 'id']),
            })
        }
    }, [selectedRows])

    // useEffect(() => {
    //     if (queryModel.orderByItems?.length === 0) {
    //         setColumns([...columns.map(x => {
    //             x.sortOrder = null
    //             return x
    //         })])
    //     }
    // }, [queryModel.updateKey])

    const getSortType = (sort) => {
        if (!sort)
            return SORT.NONE;
        else if (sort === 'ascend')
            return SORT.ASC
        else
            return SORT.DESC
    }

    const onChange = (pagination, filters, sorter) => {
        const _columns = [...dataGridProps.columns].map(x => {
            x.sortOrder = ''
            return x;
        })

        const orderByItems = []
        const col = _columns.find(x => x.key === sorter.field);
        if (sorter.order && col) {
            col.sortOrder = sorter.order
            orderByItems.push({
                name: col.columnName || sorter.field,
                operation: getSortType(sorter.order)
            })
        } else {
            if(col) {
                col.sortOrder = null
            }
        }

        const paginationQuery = {
            pageNumber: pagination.current,
            pageSize: pagination.pageSize
        };

        onFilterPageSort({
            filter: queryModel.filter,
            pagination: paginationQuery,
            orderByItems
        })
    }

    // useEffect(() => {
    //     const table = document.getElementById(`${tableId}_parent`)
    //     if(table) {
    //         table.style.transform = `scale(${scale})`;
    //         table.style.transformOrigin = 'top left';
    //         table.style.width = `${(window.innerWidth * (1/scale))-120}px`;
    //     }
    // }, [scale]);

    const useCardView = (isMobile || isNarrowViewport) && typeof dataGridProps.cardRender === 'function';
    const rowKeyName = dataGridProps.rowKey || 'id';

    const isRowSelected = (record) => {
        return selectedRows.some(r => r[rowKeyName] === record[rowKeyName]);
    };

    const toggleRowSelect = (record) => {
        const selected = isRowSelected(record);
        if (selected) {
            setSelectedRows(selectedRows.filter(r => r[rowKeyName] !== record[rowKeyName]));
        } else {
            setSelectedRows([...selectedRows, record]);
        }
    };

    const renderCardToolbar = () => (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
            padding: '8px 4px',
            borderBottom: '1px solid #f0f0f0',
            marginBottom: 8
        }}>
            <Button size="middle" icon={<ReloadOutlined />} onClick={() => refreshDataGrid()} />
            {selectedRows?.length > 0 && (
                <>
                    <Button size="middle" icon={<CloseOutlined />} onClick={() => setSelectedRows([])}>
                        {selectedRows.length} {t('selected') || 'seçili'}
                    </Button>
                </>
            )}
            <div style={{ flex: 1 }} />
            {title && title()}
        </div>
    );

    const renderCardPagination = () => {
        const totalRecords = resultModel?.pagination?.totalRecords || 0;
        const pageSize = resultModel.pagination?.pageSize || 10;
        const current = resultModel.pagination?.pageNumber || 1;
        if (dataGridProps.antdTableProps?.pagination === false) return null;
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '12px 4px',
                borderTop: '1px solid #f0f0f0',
                marginTop: 8
            }}>
                <Pagination
                    size="small"
                    total={totalRecords}
                    pageSize={pageSize}
                    current={current}
                    showSizeChanger
                    pageSizeOptions={[10, 20, 50, 100]}
                    showTotal={total => `${total} kayıt`}
                    onChange={(page, size) => {
                        onFilterPageSort({
                            filter: queryModel.filter,
                            pagination: { pageNumber: page, pageSize: size },
                            orderByItems: queryModel.orderByItems
                        });
                    }}
                />
            </div>
        );
    };

    if (useCardView) {
        const data = resultModel.data || [];
        const summaryNode = typeof dataGridProps.cardSummary === 'function'
            ? dataGridProps.cardSummary()
            : null;
        return (
            <div id={`${tableId}_parent`} className="data-grid-card-view">
                {renderCardToolbar()}
                {data.length === 0 ? (
                    <Empty description={t('No Data') || 'Kayıt yok'} style={{ padding: 32 }} />
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        {data.map((record, index) => {
                            const selected = isRowSelected(record);
                            const customClassName = typeof dataGridProps.rowClassName === 'function'
                                ? dataGridProps.rowClassName(record, index)
                                : '';
                            const onRowProps = typeof dataGridProps.onRow === 'function'
                                ? dataGridProps.onRow(record, index) || {}
                                : {};
                            const cardContent = dataGridProps.cardRender(record, {
                                index,
                                isSelected: selected,
                                toggleSelect: () => toggleRowSelect(record),
                                columns: dataGridProps.columns,
                                refresh: refreshDataGrid
                            });
                            return (
                                <div
                                    key={record[rowKeyName] ?? index}
                                    className={`data-grid-card ${customClassName || ''} ${selected ? 'data-grid-card-selected' : ''}`}
                                    {...onRowProps}
                                    style={{
                                        background: '#fff',
                                        border: `1px solid ${selected ? '#1890ff' : '#e8e8e8'}`,
                                        borderLeft: `4px solid ${selected ? '#1890ff' : '#d9d9d9'}`,
                                        borderRadius: 6,
                                        padding: 12,
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
                                        ...((onRowProps && onRowProps.style) || {})
                                    }}
                                >
                                    {dataGridProps.enableRowSelection && (
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                            <Checkbox
                                                checked={selected}
                                                onChange={() => toggleRowSelect(record)}
                                            >
                                                {selected ? 'Seçili' : 'Seç'}
                                            </Checkbox>
                                        </div>
                                    )}
                                    {cardContent}
                                </div>
                            );
                        })}
                    </div>
                )}
                {summaryNode && (
                    <div style={{ marginTop: 10 }}>
                        {summaryNode}
                    </div>
                )}
                {renderCardPagination()}
            </div>
        );
    }

    return (
        <div id={`${tableId}_parent`}>
            <Table
                size={'small'}
                scroll={{x: 1280, y: window.innerHeight-300}}
                rowKey={dataGridProps.rowKey || 'id'}
                columns={dataGridProps.columns}
                rowSelection={dataGridProps.enableRowSelection ? rowSelection : null}
                dataSource={resultModel.data}
                onChange={onChange}
                showSorterTooltip={false}
                expandable={{
                    expandedRowRender: dataGridProps.expandedRowRender,
                    rowExpandable: dataGridProps.rowExpandable,
                    //expandedRowKeys: expandedRowKeys,
                }}
                rowClassName={dataGridProps.rowClassName}
                onRow={dataGridProps.onRow}
                id={tableId}
                title={() => {
                    return (
                        <div style={{display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap'}}>
                            <Button
                                size={'small'}
                                onClick={() => refreshDataGrid()}
                            >
                                {/*{t('Add')}*/}
                                <ReloadOutlined />
                            </Button>
                            {
                                selectedRows?.length > 0 && (
                                    <Button
                                        size={'small'}
                                        onClick={() => setSelectedRows([])}
                                    >
                                        {/*{t('Add')}*/}
                                        <CloseOutlined />
                                    </Button>
                                )
                            }
                            {title && title()}
                        </div>
                    )
                }}
                pagination={{
                    total: resultModel?.pagination?.totalRecords || 0,
                    pageSize: resultModel.pagination?.pageSize || 10,
                    size: 'small',
                    current: resultModel.pagination?.pageNumber || 1,
                    showTotal: total => `Toplam ${total} kayıt`,
                    showSizeChanger: true,
                    // simple: true,
                    hideOnSinglePage: false,
                    pageSizeOptions: [10, 20, 50, 100, 250, 500]
                }}
                {...(dataGridProps.antdTableProps || {})}
            />
        </div>
    )
}
